"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DumbERC20Token__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50600054610100900460ff16158080156100315750600054600160ff909116105b8061005c575061004a3061013260201b6106cf1760201c565b15801561005c575060005460ff166001145b6100c35760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840160405180910390fd5b6000805460ff1916600117905580156100e6576000805461ff0019166101001790555b801561012c576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b50610141565b6001600160a01b03163b151590565b6110fa806101506000396000f3fe608060405234801561001057600080fd5b50600436106101165760003560e01c806379ba5097116100a2578063a457c2d711610071578063a457c2d714610226578063a9059cbb14610239578063dd62ed3e1461024c578063e30c39781461025f578063f2fde38b1461027057600080fd5b806379ba5097146101e95780638129fc1c146101f15780638da5cb5b146101f957806395d89b411461021e57600080fd5b8063313ce567116100e9578063313ce56714610181578063395093511461019057806340c10f19146101a357806370a08231146101b8578063715018a6146101e157600080fd5b806306fdde031461011b578063095ea7b31461013957806318160ddd1461015c57806323b872dd1461016e575b600080fd5b610123610283565b6040516101309190610cc3565b60405180910390f35b61014c610147366004610d2d565b610315565b6040519015158152602001610130565b6035545b604051908152602001610130565b61014c61017c366004610d57565b61032f565b60405160128152602001610130565b61014c61019e366004610d2d565b610353565b6101b66101b1366004610d2d565b610375565b005b6101606101c6366004610d93565b6001600160a01b031660009081526033602052604090205490565b6101b661038b565b6101b661039f565b6101b661041e565b6065546001600160a01b03165b6040516001600160a01b039091168152602001610130565b61012361059b565b61014c610234366004610d2d565b6105aa565b61014c610247366004610d2d565b610625565b61016061025a366004610db5565b610633565b6097546001600160a01b0316610206565b6101b661027e366004610d93565b61065e565b60606036805461029290610de8565b80601f01602080910402602001604051908101604052809291908181526020018280546102be90610de8565b801561030b5780601f106102e05761010080835404028352916020019161030b565b820191906000526020600020905b8154815290600101906020018083116102ee57829003601f168201915b5050505050905090565b6000336103238185856106de565b60019150505b92915050565b60003361033d858285610802565b61034885858561087c565b506001949350505050565b6000336103238185856103668383610633565b6103709190610e38565b6106de565b61037d610a4a565b6103878282610aa4565b5050565b610393610a4a565b61039d6000610b83565b565b60975433906001600160a01b031681146104125760405162461bcd60e51b815260206004820152602960248201527f4f776e61626c6532537465703a2063616c6c6572206973206e6f7420746865206044820152683732bb9037bbb732b960b91b60648201526084015b60405180910390fd5b61041b81610b83565b50565b600054610100900460ff161580801561043e5750600054600160ff909116105b806104585750303b158015610458575060005460ff166001145b6104bb5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b6064820152608401610409565b6000805460ff1916600117905580156104de576000805461ff0019166101001790555b61052a6040518060400160405280600e81526020016d223ab6b122a92199182a37b5b2b760911b81525060405180604001604052806004815260200163222aa6a160e11b815250610b9c565b610532610bcd565b610553336105426012600a610f2f565b61054e906103e8610f3e565b610aa4565b801561041b576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a150565b60606037805461029290610de8565b600033816105b88286610633565b9050838110156106185760405162461bcd60e51b815260206004820152602560248201527f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f77604482015264207a65726f60d81b6064820152608401610409565b61034882868684036106de565b60003361032381858561087c565b6001600160a01b03918216600090815260346020908152604080832093909416825291909152205490565b610666610a4a565b609780546001600160a01b0383166001600160a01b031990911681179091556106976065546001600160a01b031690565b6001600160a01b03167f38d16b8cac22d99fc7c124b9cd0de2d3fa1faef420bfe791d8c362d765e2270060405160405180910390a350565b6001600160a01b03163b151590565b6001600160a01b0383166107405760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b6064820152608401610409565b6001600160a01b0382166107a15760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b6064820152608401610409565b6001600160a01b0383811660008181526034602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b600061080e8484610633565b9050600019811461087657818110156108695760405162461bcd60e51b815260206004820152601d60248201527f45524332303a20696e73756666696369656e7420616c6c6f77616e63650000006044820152606401610409565b61087684848484036106de565b50505050565b6001600160a01b0383166108e05760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b6064820152608401610409565b6001600160a01b0382166109425760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b6064820152608401610409565b6001600160a01b038316600090815260336020526040902054818110156109ba5760405162461bcd60e51b815260206004820152602660248201527f45524332303a207472616e7366657220616d6f756e7420657863656564732062604482015265616c616e636560d01b6064820152608401610409565b6001600160a01b038085166000908152603360205260408082208585039055918516815290812080548492906109f1908490610e38565b92505081905550826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef84604051610a3d91815260200190565b60405180910390a3610876565b6065546001600160a01b0316331461039d5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610409565b6001600160a01b038216610afa5760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f2061646472657373006044820152606401610409565b8060356000828254610b0c9190610e38565b90915550506001600160a01b03821660009081526033602052604081208054839290610b39908490610e38565b90915550506040518181526001600160a01b038316906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a35050565b609780546001600160a01b031916905561041b81610c01565b600054610100900460ff16610bc35760405162461bcd60e51b815260040161040990610f55565b6103878282610c53565b600054610100900460ff16610bf45760405162461bcd60e51b815260040161040990610f55565b61039d610c93565b505050565b606580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b600054610100900460ff16610c7a5760405162461bcd60e51b815260040161040990610f55565b6036610c868382611004565b506037610bfc8282611004565b600054610100900460ff16610cba5760405162461bcd60e51b815260040161040990610f55565b61039d33610b83565b600060208083528351808285015260005b81811015610cf057858101830151858201604001528201610cd4565b506000604082860101526040601f19601f8301168501019250505092915050565b80356001600160a01b0381168114610d2857600080fd5b919050565b60008060408385031215610d4057600080fd5b610d4983610d11565b946020939093013593505050565b600080600060608486031215610d6c57600080fd5b610d7584610d11565b9250610d8360208501610d11565b9150604084013590509250925092565b600060208284031215610da557600080fd5b610dae82610d11565b9392505050565b60008060408385031215610dc857600080fd5b610dd183610d11565b9150610ddf60208401610d11565b90509250929050565b600181811c90821680610dfc57607f821691505b602082108103610e1c57634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fd5b8082018082111561032957610329610e22565b600181815b80851115610e86578160001904821115610e6c57610e6c610e22565b80851615610e7957918102915b93841c9390800290610e50565b509250929050565b600082610e9d57506001610329565b81610eaa57506000610329565b8160018114610ec05760028114610eca57610ee6565b6001915050610329565b60ff841115610edb57610edb610e22565b50506001821b610329565b5060208310610133831016604e8410600b8410161715610f09575081810a610329565b610f138383610e4b565b8060001904821115610f2757610f27610e22565b029392505050565b6000610dae60ff841683610e8e565b808202811582820484141761032957610329610e22565b6020808252602b908201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960408201526a6e697469616c697a696e6760a81b606082015260800190565b634e487b7160e01b600052604160045260246000fd5b601f821115610bfc57600081815260208120601f850160051c81016020861015610fdd5750805b601f850160051c820191505b81811015610ffc57828155600101610fe9565b505050505050565b815167ffffffffffffffff81111561101e5761101e610fa0565b6110328161102c8454610de8565b84610fb6565b602080601f831160018114611067576000841561104f5750858301515b600019600386901b1c1916600185901b178555610ffc565b600085815260208120601f198616915b8281101561109657888601518255948401946001909101908401611077565b50858210156110b45787850151600019600388901b60f8161c191681555b5050505050600190811b0190555056fea26469706673582212200db3956c1aa2fe97eb1e1aa8148323de4585e1523dc09141b217ed58583e386164736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class DumbERC20Token__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.DumbERC20Token__factory = DumbERC20Token__factory;
DumbERC20Token__factory.bytecode = _bytecode;
DumbERC20Token__factory.abi = _abi;
